// extracted by mini-css-extract-plugin
export default {"watermarkingQuotaAlert":"c8jn8Yj1hoA1iYVHFiLf"};